module.exports = __webpack_public_path__ + "img/519-42dfb3.png";